import React from "react";
import Icon from "@ant-design/icons";

const DeliverySvg = () => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 9.5625L17.5 5.3125H13.75V3.1875C13.75 2.60312 13.1875 2.125 12.5 2.125H1.25C0.5625 2.125 0 2.60312 0 3.1875V11.6875L1.25 12.75H2.83527C2.62242 13.0626 2.5 13.4253 2.5 13.8125C2.5 14.9861 3.6193 15.9375 5 15.9375C6.3807 15.9375 7.5 14.9861 7.5 13.8125C7.5 13.4253 7.37758 13.0626 7.16473 12.75H14.0853C13.8725 13.0626 13.75 13.4253 13.75 13.8125C13.75 14.9861 14.8693 15.9375 16.25 15.9375C17.6307 15.9375 18.75 14.9861 18.75 13.8125C18.75 13.4253 18.6275 13.0626 18.4147 12.75H20V9.5625ZM13.75 9.5625V6.375H16.3412L18.2162 9.5625H13.75Z"
    />
  </svg>
);

const DeliveryIcon = (props) => <Icon component={DeliverySvg} {...props} />;

export default DeliveryIcon;
